import { useBeeswaxDevices } from "@/modules/Beeswax/beeswax.hook";

export function usePlatformData({
  isEdit,
  areFilters,
}: {
  isEdit: boolean;
  areFilters: Record<string, boolean>;
}) {
  const {
    data: devices,
    isLoading: devicesLoading,
    isFetching: devicesFetching,
  } = useBeeswaxDevices({
    options: { enabled: isEdit && areFilters?.device_type },
  });
  return {
    devices,
    devicesLoading: devicesLoading && devicesFetching,
  };
}
